<div>
  <app-nav-bar>
    <main class="container-main">
      <ng-template #bottomSheetContent>
        <app-create-order [rType]="rType"></app-create-order>
      </ng-template>
      <ng-container *ngIf="haveOrders">
        <div class="row d-flex justify-content-between row-header-send">
          <ng-container *ngIf="rType == '0'">
            <div class="d-flex gap-8">
              <span class="send-text"> Receber dinheiro do exterior </span>

              <span class="outbound-title align-self-center"> Inbound </span>
            </div>
          </ng-container>
          <ng-container *ngIf="rType == '1'">
            <div class="d-flex gap-8">
              <span class="send-text"> Envio de dinheiro para o exterior </span>

              <span class="outbound-title align-self-center"> Outbound </span>
            </div>
          </ng-container>

          <div>
            <button
              type="button"
              (click)="openOrderModal()"
              class="btn btn-block btn-send-money"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              type="button"
            >
              {{ rType == "0" ? "Receber dinheiro" : "Enviar dinheiro" }}
            </button>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="!haveOrders && !showOrderError && !loading"
        class="accordion-item painel painel-accordion no-orders"
      >
        <div class="img-no-orders">
          <img width="240" height="160" src="assets/image/no-order-icon.svg" />
        </div>

        <p *ngIf="rType == '0'" id="txt-no-orders-register">
          Você ainda não tem nenhum recebimento cadastrado.
        </p>
        <p *ngIf="rType == '1'" id="txt-no-orders-register">
          Você ainda não tem nenhum envio cadastrado.
        </p>
        <p *ngIf="rType == '0'" id="txt-create-order">
          Crie uma ordem para receber dinheiro de várias partes do <br />
          mundo com a comodidade que precisa.
        </p>
        <p *ngIf="rType == '1'" id="txt-create-order">
          Crie uma ordem para enviar dinheiro para várias partes do <br />
          mundo com a comodidade que precisa.
        </p>

        <div class="btn-send-content">
          <button
            (click)="openOrderModal()"
            class="btn btn-block mt-0 ml-3"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            {{ rType == "0" ? "Solicitar recebimento" : "Solicitar envio" }}
          </button>
        </div>
      </div>

      <div
        *ngIf="showOrderError"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <img
            width="258"
            height="160"
            src="assets/image/error-order-icon.svg"
          />
        </div>

        <p id="txt-error-orders-register">Infelizmente encontramos um erro!</p>
        <p id="txt-error-order">
          Você pode aguardar uns instantes e tentar recarregar a <br />página
          mais uma vez.
        </p>

        <div class="btn-send-content">
          <button
            (click)="reloadPage()"
            class="btn btn-block mt-0 ml-3"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            Tentar Novamente
          </button>
        </div>
      </div>

      <ng-container *ngIf="haveOrders">
        <div class="box-order">
          <div class="padding-bottom-32 padding-top-10 header-box">
            <span *ngIf="rType == '0'" class="mb-0">
              Ordens de recebimento criadas
            </span>
            <span *ngIf="rType == '1'" class="mb-0">
              Ordens de envio criadas
            </span>
          </div>

          <div class="padding-content">
            <ng-container *ngIf="!isMobile">
              <app-table-component
                *ngIf="showTables"
                [data]="orders"
                [pageNumber]="pageNumber"
                [pageSize]="pageSize"
                [totalElements]="totalElements"
                (pageChange)="updatePageData($event)"
              ></app-table-component>
            </ng-container>

            <ng-container *ngIf="isMobile">
              <app-orders-mobile
                [data]="orders.content"
                [warrenGlobalOnly]="warrenGlobalOnly"
              ></app-orders-mobile>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </main>
  </app-nav-bar>
</div>
